export default __webpack_public_path__ + "static/media/security.cad5fd84.svg";